import { Injectable } from "@angular/core";
import { Observable, map, catchError } from "rxjs";
import { TenantWebEntity } from "./entities/tenant.web-entity";
import { TenantWebRepositoryMapper } from "./entities/tenant.web-entity-mapper";
import { TenantApiUrls } from "./tenant-api-urls";
import { HttpClient } from "@angular/common/http";
import { BaseResponse } from "../../core/domain/models";
import { Tenant } from "../../core/domain/models/tenant";
import { TenantRepository } from "../../core/repositories";
import { injectEnvironment } from "../../core/environments/environment.token";
import { TenantConfiguration } from "../../core/domain/models/tenant-configuration-model";
import { TenantConfigurationWebEntity } from "./entities/tenant-configurations.web-entity";
import { TenantConfigurationWebRepositoryMapper } from "./entities/tenant-configurations.web-entity-mapper";

@Injectable()
export class TenantWebRepository extends TenantRepository {
  TenantMapper = new TenantWebRepositoryMapper();
  TenantConfigurationMapper=new TenantConfigurationWebRepositoryMapper();
  environment = injectEnvironment();

  constructor(private http: HttpClient) {
    super();
  }

  getTenantById(request: string): Observable<Tenant> {
    return this.http
    .get<BaseResponse<TenantWebEntity>>(
      `${this.environment.planningPortalUrl}/api/${TenantApiUrls.GetTenantbyId}`,
      {
        params: {
          id: request
        }
      }
    )
    .pipe(
      map((response: BaseResponse<TenantWebEntity>) => response.result!),
      catchError((err) => {
        throw err;
      })
    )
    .pipe(map(this.TenantMapper.mapFrom));
}
 getTenantConfiguration(): Observable<TenantConfiguration[]> {
    return this.http
      .get<BaseResponse<TenantConfigurationWebEntity[]>>(
        `${this.environment.url}${TenantApiUrls.GetTenantConfigurations}`
      )
      .pipe(
        map((data: BaseResponse<TenantConfigurationWebEntity[]>) => {
          if (!Array.isArray(data.result)) {
            return [];
          }
          return data.result;
        }),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map((items) => items.map(this.TenantConfigurationMapper.mapFrom)));
  }    

 
}